// deps
import React, { ReactElement, memo } from "react";

// styles
import styles from "./MorePaymentMethodsLoadingScreen.scss";
import { withStyles } from "@swiggy-private/core-ui";

// test-ids
import { LOADING_SCREEN_TEST_IDS } from "@swiggy-private/payment-test-ids";

const PaymentMethodRow = memo(function PaymentMethodRow(): ReactElement {
    return (
        <div className={styles.paymentMethodRow}>
            <div className={styles.square}></div>
            <div className={styles.line} style={{ width: "52%" }} />
            <div className={styles.line} style={{ width: "10%" }} />
        </div>
    );
});

function MorePaymentMethodsLoadingScreen(): ReactElement {
    return (
        <div data-testid={LOADING_SCREEN_TEST_IDS.CONTAINER}>
            <div className={styles.paymentMethodContainer}>
                <PaymentMethodRow />
            </div>
            <div className={styles.paymentMethodContainer}>
                <PaymentMethodRow />
                <PaymentMethodRow />
            </div>
        </div>
    );
}

export default memo(withStyles(MorePaymentMethodsLoadingScreen, styles));
